import { nextTick } from '@vue/composition-api';

var CharState;
(function (CharState) {
    CharState[CharState["REPLACE_WITH_SEPARATOR"] = 0] = "REPLACE_WITH_SEPARATOR";
    CharState[CharState["INSERT_SEPARATOR"] = 1] = "INSERT_SEPARATOR";
    CharState[CharState["REPLACE_WITH_PATTERN"] = 2] = "REPLACE_WITH_PATTERN";
    CharState[CharState["REMOVE_CHARACTER"] = 3] = "REMOVE_CHARACTER";
    CharState[CharState["VALID"] = 4] = "VALID";
})(CharState || (CharState = {}));
function useInputMask(pattern, separators, operators) {
    var lastCaretPosition = 0;
    var lastValue = pattern;
    var separatorSet = new Set(separators);
    function applyMask(inputValue, inputElement, newChar) {
        var isDelete = inputValue.length < lastValue.length;
        var currentCaretPosition = inputElement.selectionEnd || 0;
        var valueCharacters = inputValue.split('');
        var isInvalidInput = false;
        // We parse each character of the current input, using index-based comparison on our desired pattern to apply corrections
        for (var currentCharIndex = 0; currentCharIndex < Math.min(valueCharacters.length, pattern.length); currentCharIndex++) {
            switch (getState(valueCharacters, currentCharIndex)) {
                case CharState.INSERT_SEPARATOR:
                    // Actually delete a character when doing backspace (only) delete
                    var forwardDeleteOffset = currentCaretPosition === currentCharIndex && isDelete && lastCaretPosition <= currentCaretPosition ? 1 : 0;
                    valueCharacters.splice(currentCharIndex, forwardDeleteOffset, pattern.charAt(currentCharIndex));
                    break;
                case CharState.REPLACE_WITH_SEPARATOR:
                    valueCharacters.splice(currentCharIndex, 1, pattern.charAt(currentCharIndex));
                    break;
                case CharState.REMOVE_CHARACTER:
                    valueCharacters.splice(currentCharIndex, 1);
                    break;
                case CharState.REPLACE_WITH_PATTERN:
                    valueCharacters.splice(currentCharIndex, 1, pattern.charAt(currentCharIndex));
                    break;
                case CharState.VALID:
            }
        }
        // If needed complete the rest of the input then make sure to cut it to pattern length
        var newValue = valueCharacters.join('').padEnd(pattern.length, pattern.substring(valueCharacters.length, pattern.length)).substring(0, pattern === null || pattern === void 0 ? void 0 : pattern.length);
        // If we have a new char and there's no change in the parsed value it means it was invalid
        if ((newChar && newValue === lastValue)) {
            isInvalidInput = true;
            newValue = lastValue;
        }
        lastValue = newValue;
        var direction = Math.sign(currentCaretPosition - lastCaretPosition);
        var isInputNearSeparator = separatorSet.has(valueCharacters[currentCaretPosition - 1]) && direction > -1;
        var newCaretPosition = isInputNearSeparator ? currentCaretPosition + direction : currentCaretPosition;
        // In case we have invalid input we can't use the last caret position to freeze the caret because it may be outdated
        // So we assume a new character was inserted by moving to right 1 char, so we reverse it by removing that step
        if (isInvalidInput) {
            newCaretPosition -= 1;
        }
        lastCaretPosition = newCaretPosition;
        inputElement.value = newValue;
        nextTick(function () { return moveCaret(inputElement, newCaretPosition); });
        return newValue;
    }
    function getState(inputValues, index) {
        var currentChar = inputValues[index];
        // Check if at this place we should have a separator
        if (patternHasSeparatorAt(index)) {
            if (pattern.charAt(index) === currentChar) {
                // If the char is actually a separator we don't touch it 
                return CharState.VALID;
            }
            else if (index + 1 >= pattern.length || !charIsValid(index + 1, currentChar)) {
                // If we have the wrong character, attempt to insert a separator but:
                // If the current character moved 1 to the right would be invalid, we want to replace (delete it) with separator
                return CharState.REPLACE_WITH_SEPARATOR;
            }
            else {
                // Otherwise we just want to insert the separator here and shift everything to the right
                return CharState.INSERT_SEPARATOR;
            }
            // If we should instead have an input char, check it's validity according to operators regex and position
        }
        else if (!charIsValid(index, currentChar)) {
            // Check if the next char is valid in place of this one
            if (index < pattern.length && charIsValid(index, inputValues[index + 1])) {
                // If the next char is valid just remove this one
                return CharState.REMOVE_CHARACTER;
            }
            else {
                // Otherwise replace this one with correct value from pattern
                return CharState.REPLACE_WITH_PATTERN;
            }
        }
        // If no condition applied we have a valid character at this position
        return CharState.VALID;
    }
    function patternHasSeparatorAt(index) {
        return separatorSet.has(pattern.charAt(index));
    }
    function charIsValid(index, char) {
        var _a;
        try {
            return !!(operators[pattern[index]] && ((_a = char.match(operators[pattern[index]] || '')) === null || _a === void 0 ? void 0 : _a.length)) || (pattern.charAt(index) === char);
        }
        catch (e) {
            return false;
        }
    }
    function moveCaret(el, pos) {
        var _a, _b;
        (_a = el.focus) === null || _a === void 0 ? void 0 : _a.call(el);
        (_b = el.setSelectionRange) === null || _b === void 0 ? void 0 : _b.call(el, pos, pos);
    }
    return {
        applyMask: applyMask,
    };
}

export { useInputMask };
